<template>
  <div class="project-external-staff-manage">
    <div class="app-control app-table-control">
      <div class="right-region">
        <el-input placeholder="请输入员工姓名或电话" v-model="search.value" clearable></el-input>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading">
      <el-table-column label="照片">
        <template slot-scope="{row}">
          <el-image :src="row.face_data[0].attachment_data.attachment_access_url" :preview-src-list="[row.face_data[0].attachment_data.attachment_access_url]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="external_staff_name"></el-table-column>
      <el-table-column label="近期抓拍时间" prop="project_customer_data.attr_data.project_customer_visit_last_datetime"></el-table-column>
      <el-table-column label="到访次数" prop="project_customer_data.attr_data.project_customer_day_visit_count"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="scan(row.project_customer_id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="80%" append-to-body>
      <project-external-staff-information :staffId="infoDialog.id" v-if="infoDialog.show"></project-external-staff-information>
    </el-drawer>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import ProjectExternalStaffInformation from '@/views/ProjectExternalStaffInformation.vue';

  export default {
    name: 'ProjectExternalStaffManage',
    data() {
      return {
        id: this.$route.params.id,
        infoDialog: {
          show: false,
          title: '员工详情',
          id: null
        },
        search: {
          value: ''
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    components: {
      ProjectExternalStaffInformation,
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        ProjectService.externalStaffListPage(
          this.id,
          this.search.value,
          this.page.currentPage
        ).then(res => {
          this.datas = res.data.data;
          this.page.pageSize = source.per_page;
          this.page.total = source.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      scan(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>